export default "__VITE_ASSET__B04NUIxD__"